import { render, staticRenderFns } from "./IndexLanding.vue?vue&type=template&id=35d77886&scoped=true"
import script from "./IndexLanding.vue?vue&type=script&lang=js"
export * from "./IndexLanding.vue?vue&type=script&lang=js"
import style0 from "./IndexLanding.vue?vue&type=style&index=0&id=35d77886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d77886",
  null
  
)

export default component.exports